export enum PaymentPage {
  Pending = 0,
  Returned = 1,
  RefundRequest = 2,
  SentToIpx = 3,
  SentToBritecore = 4
}